import { useState } from "react";
import { useSelector } from "src/store";
import { selectCurrentWorkspaceId } from "src/store/app";

import { useCurrentSubscriptionExpired, useWorkspaceFeature } from "@dashboard/workspaces/api/helpers";
import { License } from "@devices/types";
import AuthService from "@services/authService";
import { SecondaryButton } from "@shared/CustomButton";

import { getReasonMessage, openScreenViewPage } from "./ScreenViewButton.utils";

export const ScreenViewButton = (props: License) => {
    const [loading, setLoading] = useState(false);

    const workspaceId = useSelector(selectCurrentWorkspaceId);
    const isSubscriptionExpired = useCurrentSubscriptionExpired();
    const limit = useWorkspaceFeature("StreamSessionLimit");

    // TODO: remove this once screen view is fully implemented
    const isAdmin = AuthService.isUserAdmin();
    if (!workspaceId || !isAdmin) {
        return null;
    }

    const onClick = () => {
        if (props.device?.id) {
            setLoading(true);
            openScreenViewPage(workspaceId);
            setLoading(false);
        }
    };

    // TODO: change this once screen view is fully implemented
    const isVncEnabled = true;
    const hasOnlineDevice = !!props.device?.isOnline;
    const hasScreenMirror = !isSubscriptionExpired && isVncEnabled && hasOnlineDevice && limit > 0;

    return (
        <SecondaryButton
            onClick={onClick}
            disabled={!hasScreenMirror || loading}
            loading={loading}
            tooltipProps={{
                title: getReasonMessage({ isSubscriptionExpired, isVncEnabled, hasOnlineDevice, limit }),
            }}
        >
            <i className="fa-solid fa-display" />
        </SecondaryButton>
    );
};
